import React, { useState, useEffect } from 'react';

import S from './NumberInput.module.scss';

const NumberInput = ({ argument, onChange }) => {
  const [value, setValue] = useState('');

  // Initialiser la valeur depuis l'argument
  useEffect(() => {
    const initialValue = argument.valeurParDefaut || argument.value || '';
    setValue(initialValue.toString());
  }, [argument.valeurParDefaut, argument.value]);

  // Mettre à jour la valeur
  const handleChange = (inputValue) => {
    setValue(inputValue);
    onChange('valeurParDefaut', inputValue);
  };

  return (
    <div className={S.numberContainer}>
      <input
        type="number"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        step="any"
        placeholder="Entrez un nombre"
        className={S.numberInput}
        required={argument.obligatoire}
      />
    </div>
  );
};

export default NumberInput;
